import { render, staticRenderFns } from "./NotificationModuleModal.vue?vue&type=template&id=b18e3082&scoped=true&"
import script from "./NotificationModuleModal.vue?vue&type=script&lang=js&"
export * from "./NotificationModuleModal.vue?vue&type=script&lang=js&"
import style0 from "./NotificationModuleModal.vue?vue&type=style&index=0&id=b18e3082&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b18e3082",
  null
  
)

export default component.exports